/* fangz.js — runtime for Fangz custom sections.
   Vanilla, no dependencies. IIFE-wrapped. ~10–14kb un-minified. */
(function () {
  'use strict';

  var REDUCED_MOTION = (typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var ric = (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function')
    ? window.requestIdleCallback.bind(window)
    : function (cb) { return setTimeout(cb, 1); };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* ---------- Marquee pause-on-hover (a11y) ---------- */
  function initMarquee() {
    var marquees = document.querySelectorAll('.fz-marquee, [data-fz-marquee]');
    if (!marquees.length) return;
    marquees.forEach(function (el) {
      function pause() { el.style.animationPlayState = 'paused'; }
      function play()  { el.style.animationPlayState = 'running'; }
      el.addEventListener('mouseenter', pause);
      el.addEventListener('mouseleave', play);
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', play);
    });
  }

  /* ---------- Sticky flavour selector observer ---------- */
  function initStickyFlavourSelector() {
    var selectors = document.querySelectorAll('[data-section-type="fangz-flavour-selector"]');
    if (!selectors.length || !('IntersectionObserver' in window)) return;

    selectors.forEach(function (section) {
      var sentinel = section.querySelector('[data-fs-sentinel]');
      if (!sentinel) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 1) {
            section.classList.add('is-stuck');
          } else {
            section.classList.remove('is-stuck');
          }
        });
      }, { threshold: [1] });
      io.observe(sentinel);
    });
  }

  /* ---------- Cross-PDP nav with size/qty preservation ---------- */
  function readCurrentSizeQty() {
    var size = '';
    var qty  = '';

    // Prefer explicit data hooks if present.
    var sizeEl = document.querySelector('[data-fz-current-size], [data-product-size] :checked, [data-product-size] input:checked');
    if (sizeEl) {
      size = sizeEl.value || sizeEl.getAttribute('data-value') || sizeEl.textContent || '';
    }
    if (!size) {
      // Common Shopify variant patterns.
      var variantSelect = document.querySelector('select[name="id"], variant-radios input[type="radio"]:checked, variant-selects input[type="radio"]:checked');
      if (variantSelect) {
        size = variantSelect.value || '';
      }
    }
    if (!size) {
      var radio = document.querySelector('input[name^="options"]:checked, fieldset[name="Size"] input:checked');
      if (radio) size = radio.value || '';
    }

    var qtyInput = document.querySelector('[data-quantity-stepper] input[type="number"], input[name="quantity"], [data-fz-current-qty]');
    if (qtyInput) {
      qty = qtyInput.value || qtyInput.getAttribute('data-value') || '';
    }

    return { size: size ? String(size).trim() : '', qty: qty ? String(qty).trim() : '' };
  }

  function applySizeQtyFromUrl() {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);
    var size = params.get('size');
    var qty  = params.get('qty');
    if (!size && !qty) return;

    if (size) {
      // Try select.
      var sel = document.querySelector('select[name="id"], select[name^="options"]');
      if (sel) {
        var matched = false;
        for (var i = 0; i < sel.options.length; i++) {
          var opt = sel.options[i];
          if (opt.value === size || (opt.textContent && opt.textContent.trim().toLowerCase() === size.toLowerCase())) {
            sel.selectedIndex = i;
            matched = true;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
        if (!matched) {
          // try radio fallback
          var radio = document.querySelector('input[name^="options"][value="' + cssEscape(size) + '"]');
          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      } else {
        var radio2 = document.querySelector('input[name^="options"][value="' + cssEscape(size) + '"]');
        if (radio2) {
          radio2.checked = true;
          radio2.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    if (qty) {
      var qtyInput = document.querySelector('[data-quantity-stepper] input[type="number"], input[name="quantity"]');
      if (qtyInput) {
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        qtyInput.dispatchEvent(new Event('input',  { bubbles: true }));
      }
    }
  }

  function cssEscape(s) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_\-]/g, '\\$&');
  }

  function initCrossPdpNav() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('[data-flavour-card]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;

      var current = readCurrentSizeQty();
      if (!current.size && !current.qty) return;

      // Build URL preserving any existing params.
      try {
        var url = new URL(href, window.location.origin);
        if (current.size) url.searchParams.set('size', current.size);
        if (current.qty)  url.searchParams.set('qty',  current.qty);
        a.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (e) {
        // Fallback: append manually.
        var sep = href.indexOf('?') === -1 ? '?' : '&';
        var extras = [];
        if (current.size) extras.push('size=' + encodeURIComponent(current.size));
        if (current.qty)  extras.push('qty='  + encodeURIComponent(current.qty));
        if (extras.length) a.setAttribute('href', href + sep + extras.join('&'));
      }
    }, true);
  }

  /* ---------- Reveal observer ---------- */
  function initRevealObserver() {
    var els = document.querySelectorAll('.fz-reveal');
    if (!els.length) return;

    if (REDUCED_MOTION || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('fz-reveal--in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          entry.target.classList.add('fz-reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: [0.25] });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Quantity stepper messaging (per spec §6.2) ---------- */
  function quantityMessage(q) {
    q = parseInt(q, 10);
    if (!q || q < 1) return '';
    if (q === 1) return 'Single chew';
    if (q === 2) return 'Buy 1 more, save 10%';
    if (q >= 3 && q <= 4) return 'Saving 10% — buy 5+, save 20%';
    return 'Saving 20% — best per-chew value';
  }

  function initQuantityStepper() {
    var steppers = document.querySelectorAll('[data-quantity-stepper]');
    if (!steppers.length) return;

    steppers.forEach(function (stepper) {
      var input = stepper.querySelector('input[type="number"], input[name="quantity"]');
      var msg   = stepper.querySelector('[data-quantity-message]') ||
                  document.querySelector('[data-quantity-message]');
      if (!input) return;

      function update() {
        var text = quantityMessage(input.value);
        if (msg) msg.textContent = text;
        stepper.setAttribute('data-current-qty', input.value || '');
      }

      // +/- buttons
      var dec = stepper.querySelector('[data-qty-decrement], [data-qty-minus]');
      var inc = stepper.querySelector('[data-qty-increment], [data-qty-plus]');
      if (dec) dec.addEventListener('click', function (e) {
        e.preventDefault();
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) { input.value = v - 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (inc) inc.addEventListener('click', function (e) {
        e.preventDefault();
        var v = parseInt(input.value, 10) || 0;
        input.value = v + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('input',  update);
      input.addEventListener('change', update);
      update();
    });
  }

  /* ---------- Subscribe & Save toggle (per spec §6.2) ---------- */
  function initSubscribeToggle() {
    var toggles = document.querySelectorAll('[data-subscribe-toggle]');
    if (!toggles.length) return;

    var OFF_TEXT = 'Buy once';
    var ON_TEXT  = 'Subscribe & save 15% — every 4 weeks, skip or cancel anytime';

    toggles.forEach(function (toggle) {
      var msg = toggle.querySelector('[data-subscribe-message]') ||
                document.querySelector('[data-subscribe-message]');
      var input = toggle.querySelector('input[type="checkbox"], input[type="radio"]') || toggle;

      function update() {
        var on = false;
        if (input && 'checked' in input) {
          on = !!input.checked;
        } else {
          on = toggle.classList.contains('is-on') || toggle.getAttribute('aria-pressed') === 'true';
        }
        if (msg) msg.textContent = on ? ON_TEXT : OFF_TEXT;
        toggle.setAttribute('data-state', on ? 'on' : 'off');
      }

      if (input && input !== toggle) {
        input.addEventListener('change', update);
      }
      toggle.addEventListener('click', function () {
        // Allow elements that are buttons to flip their own state.
        if (toggle.hasAttribute('aria-pressed')) {
          toggle.setAttribute('aria-pressed', toggle.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        }
        // Defer one frame so the input checked state updates first.
        setTimeout(update, 0);
      });

      update();
    });
  }

  /* ---------- Spirulina desktop sticky ATC column ---------- */
  function initSpirulinaDesktopStickyDetails() {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    var main = document.querySelector('main[data-template="product.fangz-spirulina"]');
    if (!main) return;

    var details = main.querySelector('.product-details.sticky-content--desktop');
    if (!details) return;

    if (main.__fzStickySidebarSchedule) {
      main.__fzStickySidebarSchedule();
      return;
    }

    var mq = window.matchMedia('(min-width: 750px)');
    var rafId = 0;

    function applyHeightVar() {
      rafId = 0;
      if (!mq.matches) {
        details.style.removeProperty('--fz-sticky-panel-height');
        return;
      }
      var h = Math.ceil(details.getBoundingClientRect().height);
      if (h > 0) {
        details.style.setProperty('--fz-sticky-panel-height', h + 'px');
      }
    }

    function schedule() {
      if (rafId) return;
      rafId = window.requestAnimationFrame
        ? window.requestAnimationFrame(applyHeightVar)
        : setTimeout(applyHeightVar, 16);
    }

    main.__fzStickySidebarSchedule = schedule;

    schedule();
    window.addEventListener('load', schedule, { once: true });
    window.addEventListener('resize', schedule);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', schedule);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(schedule);
    }

    if (typeof ResizeObserver === 'function') {
      var ro = new ResizeObserver(schedule);
      ro.observe(details);
    } else {
      setTimeout(schedule, 300);
      setTimeout(schedule, 1200);
    }
  }

  /* ---------- Boot ---------- */
  ready(function () {
    initMarquee();
    initStickyFlavourSelector();
    initCrossPdpNav();
    initQuantityStepper();
    initSubscribeToggle();
    initSpirulinaDesktopStickyDetails();
    applySizeQtyFromUrl();
    ric(initRevealObserver);

    document.addEventListener('shopify:section:load', function () {
      initSpirulinaDesktopStickyDetails();
    });
  });
})();
